import { Injectable } from '@angular/core';

export interface RegisterableDropdown {
    forceClose(): void;
}

@Injectable({ providedIn: 'root' })
export class DropdownRegistryService {
    private current?: RegisterableDropdown;

    // called when a dropdown opens — closes the previously open one
    opened(dropdown: RegisterableDropdown): void {
        if (this.current && this.current !== dropdown) {
            this.current.forceClose();
        }
        this.current = dropdown;
    }

    // called when a dropdown closes
    closed(dropdown: RegisterableDropdown): void {
        if (this.current === dropdown) {
            this.current = undefined;
        }
    }
}